module.exports = __webpack_public_path__ + "img/2.0951f534.png";